import { FacebookLogin } from '@capacitor-community/facebook-login';

export const logFacebookEvent = async (eventName: string) => {
  return FacebookLogin.logEvent({ eventName: eventName });
};
